'use strict';

class UbicacionModalController {
  constructor($uibModalInstance, $stateParams, data) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
    this.$stateParams = $stateParams;
    this.foto = data.foto;
    this.fotos = data.fotos;
  }

  $onInit() {
    this.$$iniciarLeaflet();
    if (this.foto && this.foto.coordenadas && this.foto.coordenadas.coordinates && this.foto.coordenadas.coordinates[0] && this.foto.coordenadas.coordinates[1]) {
      this.mapa.centro = {
        lat: this.foto.coordenadas.coordinates[1],
        lng: this.foto.coordenadas.coordinates[0],
        zoom: 15,
      };
    } else {
      this.mapa.centro = {
        lat: -16.5286043,
        lng: -68.1798767,
        zoom: 15,
      };
    }

    let icon = {
      iconUrl: 'images/marker-sm-green.png',
      iconSize: [38, 40]
    };
    let icon2 = {
      iconUrl: 'images/marker-sm-red.png',
      iconSize: [38, 40]
    };
    for (let i in this.fotos) {
      if (this.fotos[i].coordenadas && this.fotos[i].coordenadas.coordinates && this.fotos[i].coordenadas.coordinates[0] && this.fotos[i].coordenadas.coordinates[1]) {
        this.mapa.marcadores.push({
          lat: this.fotos[i].coordenadas.coordinates[1],
          lng: this.fotos[i].coordenadas.coordinates[0],
          focus: (this.fotos[i].nro==this.foto.nro),
          draggable: false,
          message: 'Foto '+this.fotos[i].nro,
          icon: (this.fotos[i].nro==this.foto.nro)? icon: icon2,
        });
      }
    }
  }

  cerrar() {
    this.$uibModalInstance.close(false);
  }

  $$iniciarLeaflet() {
    this.mapa = {
      marcadores: [],
      defaults: {
        minZoom: 5,
      },
      maxbounds: {
        northEast: {
          lat: -8.433237,
          lng: -71.367187
        },
        southWest: {
          lat: -23.596439,
          lng: -56.118164
        }
      }
    };
    let layers = {
      geobolivia_topo: {
        name: 'GeoBolivia Topográfico',
        url: 'https://test.geo.gob.bo/raster/service/wmts?',
        type: 'wms',
        visible: true,
        layerParams: {
          layers: 'mapbox_terrain',
          format: "image/png",
          transparent: true,
          //crs: L.CRS.EPSG4326,
          //version: '1.1.1',
        },
        layerOptions: {
          attribution: '<a href="https://geo.gob.bo" target="_blank">GeoBolivia</a>',
          continuousWorld: false
        }
      },
      geobolivia_sat: {
        name: 'GeoBolivia Satelital',
        url: 'https://test.geo.gob.bo/raster/service/wms?',
        type: 'wms',
        visible: true,
        layerParams: {
          layers: 'mapbox_bolivia',
          format: "image/png",
          transparent: true,
          //crs: L.CRS.EPSG4326,
          //version: '1.1.1',
        },
        layerOptions: {
          attribution: '<a href="https://geo.gob.bo" target="_blank">GeoBolivia</a>',
          continuousWorld: false
        }
      },
      openstreetmap: {
        name: 'OpenStreetMap',
        type: 'xyz',
        url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        layerOptions: {
          subdomains: ['a', 'b', 'c'],
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
          continuousWorld: false
        }
      },
      arcgis: {
        name: 'Topográfico',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
        type: 'xyz',
        layerOptions: {
          attribution: '<a href="http://www.arcgis.com/home/webmap/viewer.html" target="_blank">ArcGIS</a>',
          continuousWorld: false
        }
      },
      arcgisimage: {
        name: 'Imágenes',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        type: 'xyz',
        layerOptions: {
          attribution: '<a href="http://www.arcgis.com/home/webmap/viewer.html" target="_blank">ArcGIS</a>',
          continuousWorld: false
        }
      },
      mapbox_api: {
        name: 'Escala de grises',
        url: 'https://api.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
        type: 'xyz',
        layerOptions: {
          apikey: 'pk.eyJ1IjoiY2hlbG9hbGVqb2MiLCJhIjoiY2lod2lkZHdrMDJueHUxbTFqMXRodGUzdyJ9.Vs-56Km_o5AXT9N5QrcLsw',
          mapid: 'landplanner.map-dsn5dtki',
          attribution: '<a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a>'
        }
      },
    };

    this.mapa.layers = {
      baselayers: layers
    };
  }

}

export default UbicacionModalController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/planilla-proyecto/vista-ubicacion/modal.controller.js